import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.UserList', {
    nameColumnText: 'Name',
    emailColumnText: 'Email',
    roleColumnText: 'Role',
    permissionsColumnText: 'Extra permissions',
    statusColumnText: 'Status',
    TFAColumnText: '2FA',
    delegateColumnText: 'Substitute',
    delegateDateStartColumnText: 'Start date',
    delegateDateEndColumnText: 'End date',
    delegateTimeZoneColumnText: 'Time zone',
    showContextHelp: 'Show context help',
    errorCurrentUserDelegate: 'You cannot set a Substitute for yourself because you are a Substitute for another user',
    errorUserAlreadyDelegated:
        '{delegateName} cannot be selected as a Substitute because they have set a Substitute ({delegateDelegateName}) for themselves',
});
